import {
  CREATE_CATALOGITEM_NEW_RECORD,
  CREATE_CATALOGITEM_NEW_RECORD_SUCCESS,
  CREATE_CATALOGITEM_NEW_RECORD_ERROR,

  GET_CATALOGITEM_NEW_RECORD,
  GET_CATALOGITEM_NEW_RECORD_SUCCESS,
  GET_CATALOGITEM_NEW_RECORD_ERROR,

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,

  UPDATE_CATALOGITEM_NEW_RECORD,
  UPDATE_CATALOGITEM_NEW_RECORD_SUCCESS,
  UPDATE_CATALOGITEM_NEW_RECORD_ERROR,

  GET_CATALOGITEM_TERMS,
  GET_CATALOGITEM_TERMS_SUCCESS,
  GET_CATALOGITEM_TERMS_ERROR,
} from "../actions";

export const getCatalogItemTerms = (vocabularyId, history) => ({
  type: GET_CATALOGITEM_TERMS,
  payload: { vocabularyId, history }
});

export const getCatalogItemTermsSuccess = (recordCreated) => ({
  type: GET_CATALOGITEM_TERMS_SUCCESS,
  payload: recordCreated,
});

export const getCatalogItemTermsError = (message) => ({
  type: GET_CATALOGITEM_TERMS_ERROR,
  payload: { message },
});

export const getCatalogItemNewRecord = (catalogItemId, history, activityInfo) => ({
  type: GET_CATALOGITEM_NEW_RECORD,
  payload: { catalogItemId, history, activityInfo }
});

export const getCatalogItemNewRecordSuccess = (recordCreated) => ({
  type: GET_CATALOGITEM_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const getCatalogItemNewRecordError = (message) => ({
  type: GET_CATALOGITEM_NEW_RECORD_ERROR,
  payload: { message },
});

export const trashCatalogItem = (catalogItemId, history, activityInfo) => ({
  type: UPDATE_CATALOGITEM_NEW_RECORD,
  payload: { catalogItemId, history, activityInfo }
});

export const trashCatalogItemSuccess = (recordCreated) => ({
  type: UPDATE_CATALOGITEM_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const trashCatalogItemError = (message) => ({
  type: UPDATE_CATALOGITEM_NEW_RECORD_ERROR,
  payload: { message },
});

export const createCatalogItemNewRecord = (newRecord, history, activityInfo) => ({
  type: CREATE_CATALOGITEM_NEW_RECORD,
  payload: { newRecord, history, activityInfo }
});

export const createCatalogItemNewRecordSuccess = (recordCreated) => ({
  type: CREATE_CATALOGITEM_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createCatalogItemNewRecordError = (message) => ({
  type: CREATE_CATALOGITEM_NEW_RECORD_ERROR,
  payload: { message },
});


export const hideNewRecordPanel = () => ({
  type: PANEL_NEW_RECORD_HIDE_CLICK,
  payload: {},
});

export const toggleNewRecordPanel = () => ({
  type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  payload: {},
});

export const setRecordType = (recordTypeSelected) => ({
  type: SET_RECORD_TYPE,
  payload: { recordTypeSelected },
});

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});